module.exports = __webpack_public_path__ + "img/X.6d9b478.jpg";